import { render, staticRenderFns } from "./byVehicleTableBox.vue?vue&type=template&id=3a00ffaa&scoped=true&"
import script from "./byVehicleTableBox.vue?vue&type=script&lang=js&"
export * from "./byVehicleTableBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a00ffaa",
  null
  
)

export default component.exports